import styled from 'styled-components'
import { backgroundOrange, textMuted, border1 } from '@/theme/colors'
import { media, layers } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { Button } from '@components/Button'
import { ShellRow } from '@components/Page'
import { Pill } from '@components/Pill'

/* Full-bleed sticky bar: background/border span the viewport and the vertical
   padding (incl. the notch inset) lives here; the horizontal gutter and the
   brand↔actions row move to HeaderInner (the shared ShellRow) so the brand
   lines up with the centered page content below. */
export const HeaderBar = styled.header`
	position: sticky;
	top: 0;
	z-index: ${layers.sticky};
	padding: 16px 0;
	/* Clear the notch / status bar when the page is viewed full-bleed on a phone. */
	padding-top: max(16px, env(safe-area-inset-top));
	background: ${backgroundOrange};
	border-bottom: 1px solid ${border1};

	${media.bentoCollapse} {
		padding: 14px 0;
		padding-top: max(14px, env(safe-area-inset-top));
	}

	${media.phone} {
		padding: 10px 0;
		padding-top: max(10px, env(safe-area-inset-top));
	}
`

export const HeaderInner = styled(ShellRow)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;

	${media.phone} {
		gap: 8px;
	}
`

/** Link wrapper only — the lockup itself is the shared @components/BrandMark. */
export const Brand = styled.a`
	display: inline-flex;
	align-items: center;
	text-decoration: none;
`

export const HeaderRight = styled.div`
	display: flex;
	align-items: center;
	gap: 14px;

	${media.phone} {
		gap: 8px;
	}
`

export const ReadOnlyPill = styled(Pill).attrs({ $tone: 'outline' as const, $size: 'md' as const })`
	color: ${textMuted};
	background: transparent;

	${media.phone} {
		gap: 5px;
		font-size: ${fontSizes.micro};
		padding: 3px 8px;
	}
`

/** The "Shared trip · " lead-in — dropped on phones so only "view only" shows. */
export const PillPrefix = styled.span`
	${media.phone} {
		display: none;
	}
`

/** Rendered as an anchor at the call site. */
export const CtaButton = styled(Button).attrs({ variant: 'cool' as const })`
	padding: 10px 18px;

	/* Small CTA per the mobile handoff. */
	${media.phone} {
		font-size: ${fontSizes.caption};
		padding: 8px 13px;
	}
`
